import TopBar from "../components/TopBar";

/* =========================
   CLOUD STYLES & ANIMATIONS
========================= */
const cloudStyles = `
  @keyframes floatCloudLeft {
    0% { transform: translateX(0px); }
    50% { transform: translateX(15px); }
    100% { transform: translateX(0px); }
  }
  @keyframes floatCloudRight {
    0% { transform: translateX(0px); }
    50% { transform: translateX(-15px); }
    100% { transform: translateX(0px); }
  }

  /* FLUFFY CLOUD BASE */
  .cloud-shape {
    position: absolute;
    background: rgba(255, 255, 255, 0.92);
    border-radius: 50px;
    pointer-events: none;
    filter: drop-shadow(0 6px 12px rgba(255, 255, 255, 0.6));
    z-index: 0;
  }

  /* TOP PUFFS */
  .cloud-shape::before,
  .cloud-shape::after {
    content: '';
    position: absolute;
    background: rgba(255, 255, 255, 0.92);
    border-radius: 50%;
  }

  .cloud-shape::before {
    width: 50%;
    height: 110%;
    top: -45%;
    left: 15%;
  }

  .cloud-shape::after {
    width: 42%;
    height: 90%;
    top: -35%;
    right: 15%;
  }

  /* POSITIONS & SIZES */
  .cloud1 {
    left: -20px;
    top: 80px;
    width: 170px;
    height: 50px;
    animation: floatCloudLeft 8s ease-in-out infinite;
  }

  .cloud2 {
    right: -25px;
    top: 160px;
    width: 190px;
    height: 55px;
    animation: floatCloudRight 9s ease-in-out infinite;
  }

  .cloud3 {
    left: -30px;
    top: 450px;
    width: 160px;
    height: 48px;
    animation: floatCloudLeft 10s ease-in-out infinite;
  }

  .cloud4 {
    right: -30px;
    top: 620px;
    width: 180px;
    height: 52px;
    animation: floatCloudRight 11s ease-in-out infinite;
  }
`;

export default function HowToPlay({ onClose }) {
  return (
    <div style={styles.overlay}>
      <style>{cloudStyles}</style>

      {/* CLOUDS VISIBLE IN BACKGROUND */}
      <div className="cloud-shape cloud1"></div>
      <div className="cloud-shape cloud2"></div>
      <div className="cloud-shape cloud3"></div>
      <div className="cloud-shape cloud4"></div>

      <TopBar onBack={onClose} />

      <div style={styles.card}>
        <h1 style={{ marginTop: 0 }}>How to play</h1>

        <p>Guess the mystery city in 6 tries!</p>

        <p>
          Every day there will be a flight taken from yesterday’s city to a new
          destination city.
        </p>

        <p>After each guess the following will be revealed:</p>

        <ul>
          <li><b>Continent:</b> 🟩 if your guess is on the correct continent</li>
          <li>
            <b>Country:</b> 🟩 if your guess is in the correct country,  🟨 if your guess borders the
            correct country
          </li>
          <li><b>City:</b> 🟩 if your guess is the correct city</li>
        </ul>

        <p>
          After each incorrect guess, a new clue will be revealed.
        </p>

        <p>
          A new Flightle is released at midnight each day!
        </p>
      </div>
    </div>
  );
}

const styles = {
  overlay: {
    position: "fixed",
    inset: 0,
    background: `linear-gradient(to bottom, #deecfc 0%, #dff3ff 45%, #eef7ff 100%)`,
    display: "flex",
    alignItems: "flex-start",
    justifyContent: "center",
    paddingTop: 70,
    paddingBottom: 24, 
    overflowX: "hidden",
    overflowY: "auto",
    zIndex: 9999
  },
  card: {
    position: "relative",
    zIndex: 1,
    background: "rgba(255, 255, 255, 0.94)",
    backdropFilter: "blur(10px)",
    borderRadius: 16,
    padding: 20,
    maxWidth: 600,
    width: "100%",
    margin: "0 auto 24px",
    fontFamily: "'Inter', sans-serif"
  }
};